enum NewsletterList {
  // NOTE: if newsletters are added or removed, be sure to update listToGroupId() in
  // app/(main)/api/newsletter/signup/route.ts accordingly.
  default = 'default',
  drama = 'drama',
  science = 'science',
  mystery = 'mystery',
}

export default NewsletterList
